export enum ConnextraType {
	HOME = "F2P_Playoffs_Homepage",
	REGISTRATION_START = "F2P_Playoffs_RegStart",
	REGISTRATION_CONFIRM = "F2P_Playoffs_RegConfirm",
	LOGIN = "F2P_Playoffs_LoggedIn",
	LP_PAGE = "F2P_PlayoffsMyPicks_LandingPage",
	PICK_START = "F2P_PlayoffsMyPicks_PickStart",
	PICK_CONFIRM = "F2P_PlayoffsMyPicks_PickConfirm",
	SHARE_PICKS = "F2P_PlayoffsMyPicks_ShareButton",
	HP_PAGE = "F2P_PlayoffsExplore_LandingPage",
	HP_RESET_PICKS = "F2P_PlayoffsExplore_CancelPick",
	HP_SUBMIT_PICKS = "F2P_PlayoffsExplore_SubmitPick",
	HP_PICKS_UPDATE = "F2P_PlayoffsExplore_UpdatePick",
}

const CONNEXTRA_URL = `https://us.connextra.com/dcs/tagController/tag/11935e1e2233/`;

export const createConnextraScript = (type: ConnextraType, accountId: number = 0) => {
	const elementName = "script";
	const SCRIPT_ID = "connextra-tagging";

	document.getElementById(SCRIPT_ID)?.remove();
	const src = `${CONNEXTRA_URL}${type}`;

	const url = new URL(src);

	if (accountId) {
		url.searchParams.append("AccountID", `${accountId}`);
	}

	const script = document.createElement(elementName);
	script.id = SCRIPT_ID;
	script.src = url.toString();
	script.async = true;
	script.defer = true;

	const firstJS = document.getElementsByTagName(elementName)[0];
	firstJS.parentNode!.insertBefore(script, firstJS);

	console.log("ConnextraType---", type);

	return script;
};
